export default __webpack_public_path__ + "static/media/Maria_Drueco_AHV_In_Moms_We_Trust.074b0ea9.jpg";